import React from 'react';
import PropTypes from 'prop-types';
import './Spinner.scss';

const Spinner = ({ className, width }) => (
  <div
    className={['spinner', ...[className]].join(' ')}
    style={{ width }}
  >
    <svg className="circular" viewBox="25 25 50 50">
      <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  </div>
);

Spinner.defaultProps = {
  className: '',
  width: '1rem',
};

Spinner.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Loading/Spinner/Spinner.jsx